import { render, staticRenderFns } from "./Desbravando.vue?vue&type=template&id=28c23c36&"
import script from "./Desbravando.vue?vue&type=script&lang=js&"
export * from "./Desbravando.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports